import {
  ChangeDetectionStrategy,
  ChangeDetectorRef,
  Component,
  Inject,
  ViewChild,
  ViewContainerRef,
} from '@angular/core';
import {
  MODEL,
  LinkModel,
  DefaultLinkComponent,
  LabelModel,
} from '@rxzu/angular';

@Component({
  selector: 'rxzu-risk-management-link',
  templateUrl: './risk-management-link.component.html',
  styleUrls: ['./risk-management-link.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class RiskManagementLinkComponent extends DefaultLinkComponent {
  @ViewChild('labelLayer', { read: ViewContainerRef, static: true })
  labelLayer!: ViewContainerRef;

  constructor(
    @Inject(MODEL) public model: LinkModel,
    cdRef: ChangeDetectorRef
  ) {
    super(model, cdRef);
    const _label = this.model.getLabel();

    this.model.setLabel(new LabelModel({ namespace: 'risk-management', text: _label?.getText() ?? '' }));
  }
}
